import { render, staticRenderFns } from "./IncomesCollapsableItem.vue?vue&type=template&id=d5cfe6b4&"
import script from "./IncomesCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./IncomesCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports